export const companyConstants = {
    GETALL_COMPANYSETTINGS_REQUEST: "COMPANYSETTINGS_REQUEST",
    GETALL_COMPANYSETTINGS_SUCCESS: "COMPANYSETTINGS_SUCCESS",
    GETALL_COMPANYSETTINGS_FAILURE: "COMPANYSETTINGS_FAILURE",

    UPDATECOMPANYSETTINGS_REQUEST: "UPDATE_COMPANY_SETTINGS_REQUEST",
    UPDATECOMPANYSETTINGS_SUCCESS: "UPDATE_COMPANY_SETTINGS_SUCCESS",
    UPDATECOMPANYSETTINGS_FAILURE: "UPDATE_COMPANY_SETTINGS_FAILURE",
}